<template>
  <div class="page-container usercard">
    <div class="info-left">
      <div class="l-l">
        <!--<div class="fw700 line">张三</div>-->
        <div class="ll-b">
          <el-tooltip class="item" effect="dark" content="此患者为黑名单患者" placement="top-start">
            <img v-if="patientData.incapableState == 2" style="width: 20px;margin-right: 10px;" src="./img/blackPeople.png" alt="">
          </el-tooltip>
          <div v-if="!showName" class="fw700">{{ hideCode(patientData.userName, 1, 0) }}</div>
          <div v-else class="fw700">{{ patientData.userName }}</div>

          <div class="image-icon eyes">
            <img @click="showName = !showName" v-if="!showName" src="./img/隐藏.png" alt="">
            <img @click="showName = !showName" v-else src="./img/查看.png" alt="">
          </div>
        </div>
        <div class="pingyin">
          <span v-text="pingyinText"></span>
          <el-popover
            style="z-index: 9999;"
            :popper-class="'my-poper'"
            width="320"
            trigger="click"
            placement="bottom-start">
            <div class="pingyin_tag" v-if="patientTagList.length>0">
              <el-tag v-for="item in patientTagList" :key="item.tagId" size="medium" style="margin: 0 10px 10px 0;">{{item.tagName}}</el-tag>
            </div>
            <div v-else>
              （无标签）
            </div>
            <!-- <i class="el-icon-collection-tag" slot="reference"></i> -->
            <img src="./img/notag.png" alt="loading" slot="reference" style="width: 20px;height:20px;line-height:20px;">
          </el-popover>
        </div>
      </div>
      <div class="l-r">
        <div class="line" style="text-align: right;">住院号：{{ getInfoKey('住院号') }}</div>
        <div class="info">
          <!--<div class="tags"  style="font-size: 12px;">-->
          <!--生存；死亡-->
          <!--</div>-->
          <div class="tags" v-if="patientData.latelyFollowupState != 0" style="font-size: 14px;">
            {{ getExistenceState(patientData.existenceState) }}；{{ getFollowupState(patientData.latelyFollowupState) }}
          </div>
          <span>{{ patientData.userSex }}</span>
          <span>{{ patientData.userAge }}岁</span>
          <span class="image-icon" v-if="patientData.isRegisterApp"><img src="./img/logo.png" alt=""></span>
          <span class="text-icon" v-if="registerState">茁</span>
        </div>
      </div>
      <!--<div class="name-container">-->
      <!--<div class="name-inner">-->
      <!--<span v-text="pingyinText" class="pinying"></span>-->
      <!--<el-popover-->
      <!--placement="top-start"-->
      <!--title=""-->
      <!--width="150"-->
      <!--trigger="hover"-->
      <!--:content="patientData.userName">-->
      <!--<span slot="reference" class="name">{{hideCode(patientData.userName,1,0)}}</span>-->
      <!--&lt;!&ndash;<el-button slot="reference">hover 激活</el-button>&ndash;&gt;-->
      <!--</el-popover>-->
      <!--</div>-->
      <!--<span class="sex" style="margin-left: 5px" v-text="`${patientData.userSex}`"></span>-->
      <!--</div>-->
      <!--<div v-if="patientData.latelyFollowupState != 0" style="font-size: 14px;">-->
      <!--{{getExistenceState(patientData.existenceState)}}；{{getFollowupState(patientData.latelyFollowupState)}}-->
      <!--</div>-->
    </div>
    <div class="info-right">
      <!--<dl v-for="(item,index) in infoKeyList" :key="index">-->
      <!--<dt>{{item.infoKey}}</dt>-->
      <!--<dd>{{item.infoValue}}</dd>-->
      <!--</dl>-->
      <div v-if="item.infoKey != '住院号'" class="right-list" v-for="(item,index) in infoKeyList" :key="index">
        <div class="list-key">{{ item.infoKey }}</div>
        <span style="color: #a2a2a2;">：</span>
        <div v-if="item.infoValue.length > 13" class="list-value">
          <el-popover
              style="z-index: 9999;"
              :popper-class="'my-poper'"
              placement="top-start"
              title=""
              width="150"
              trigger="hover"
              :content="item.infoValue">
            <div slot="reference" class="list-value-inner">
              {{ item.infoValue }}
            </div>
          </el-popover>
        </div>
        <div v-else>
          {{ item.infoValue }}
        </div>
      </div>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
// 患病者-- 资料页 -- 用户信息 Card
import defaultImg from './img/self.jpg'
import vPinyin from './js/vue-py'
import {RestReferenceControllerGetExhibition} from "@src/assets/js/api.js"
import dayjs from 'dayjs'
import {RestNewFollowupCallCenterServiceGetHuiZhuoRegisterState} from "../../assets/js/api";

export default {
  name: 'PatientDataPage',
  data() {
    return {
      registerState: false,
      showName: false,
      pingyinText: "",
      userInfo: {
        name: '',
        nameConvert: "",
        sex: '男',
        isApp: true,
        age: 48,
        hosNum: '652782',
        surgeryDate: '2010-06-23',
        surgerDoctor: '樊家',
        surgeryDes: '无无无无无,'
      },
      defaultImg,
      infoKeyList: [{"infoKey": "年龄", "infoValue": "74"}, {
        "infoKey": "住院号",
        "infoValue": "20210623"
      }, {"infoKey": "主诊医生", "infoValue": ""}, {"infoKey": "治疗方式", "infoValue": ""}, {
        "infoKey": "治疗日期",
        "infoValue": ""
      }],
      patientTagList: [],
    }
  },
  props: {
    patientData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  components: {},
  computed: {

    medical() {
      let arr = []
      if (this.patientData.medicalRecordName) {
        arr.push(this.patientData.medicalRecordName)
      }
      if (this.patientData.otherdDiagnosis) {
        arr.push(this.patientData.otherdDiagnosis)
      }
      return arr.join(';');
    },
  },
  watch: {
    'patientData.userName': {
      handler(val) {
        this.pingyinText = vPinyin.chineseToPinYin(val)
      },
      deep: true,
      immediate: true
    },
  },
  methods: {
    getInfoKey(key) {
      if(this.infoKeyList.find(item => item.infoKey == key)) {
        return this.infoKeyList.find(item => item.infoKey == key).infoValue
      }
    },
    getExistenceState(val) {
      switch (val) {
        case true:
          return '死亡'
          break
        case false:
          return '生存'
          break
        case null:
          return ''
      }
    },
    getFollowupState(val) {
      switch (val) {
        case 11:
          return '拒绝随访'
          break
        case 10:
          return '失访'
          break
        case 12:
          return '死亡'
          break
        case 9:
          return '完成'
          break
        case 5:
          return '线上完成'
          break
      }
    },
    async getExhibition() {
      let request = new RestReferenceControllerGetExhibition()
      request.p_taskId = localStorage.getItem('taskId')
      request.p_followupPatientId = this.patientData.followupPatientId
      request.p_nowUserId = sessionStorage.getItem('userid')
      await request.send()
      return request.result
    },

    hideCode(str, frontLen, endLen) {
      var len = str.length - frontLen - endLen;
      var xing = '';
      for (var i = 0; i < len; i++) {
        xing += '*';
      }
      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    },
    init() {
      this.getExhibition()
          .then(res => {
            console.log(res);
            this.infoKeyList = res.retValue.map(item => {
              return {
                infoKey: item.infoKey,
                infoValue: item.infoValue || ""
              }
            })
            this.isRegisterHuizhuo({
              patientId: this.patientData.followupPatientId,
              followupTaskId: localStorage.getItem('taskId')
            }).then(res => {
              console.log(res);
              this.registerState = res.retValue.registerState
            })
          })
      this.getPatientTags()
      this.$forceUpdate()
    },
    getPatientTags(){
      console.log('getPatientTags');
      this.patientTagList = []
      this.$store.dispatch('requestHandler',
          {
            fn: 'RestNewFollowupCallCenterServiceQueryTagByPatient',
            params: {
              followupPatientId: this.patientData.followupPatientId
            }
          }
        ).then(res => {
          if (res.status==0) {
            this.patientTagList = res.retValue
            this.$emit("getPatientTags", res.retValue)
          }
        })
    },
    async isRegisterHuizhuo(p) {
      let result = await this.$store.dispatch('requestHandler', {
        fn: 'RestNewFollowupCallCenterServiceGetHuiZhuoRegisterState',
        params: {
          patientId: p.patientId,
          followupTaskId: p.followupTaskId,
        }
      })
      return result
    }

  },
  filters: {
    millisecondToDate(value) {
      //console.log(value ,dayjs(parseInt(value)))
      let date = new Date(value);

      if (!(date instanceof Date && !isNaN(date.getTime()))) {
        return value;
      }
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let days = date.getDate();
      return '' + year + '-' + (month < 10 ? ('0' + month) : month) + '-' + (days < 10 ? ('0' + days) : days);
    },
  },
  mounted() {
    this.init()
    // console.log('pinyin',pinyin("重心"))
    // console.log(vPinyin.chineseToPinYin('重心'));
  },

}
</script>
<style lang="scss">
.my-poper {
  z-index: 9999 !important;
 }
.el-tooltip__popper {
  z-index: 9999!important;
}
</style>
<style scoped lang="scss">
.page-container.usercard {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 400px;
  min-height: 230px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
  border-radius: 8px;
  padding: 20px;
  box-sizing: border-box;

  .info-left {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    padding-bottom: 10px;

    .tags {
      /*border: 1px solid #ccc;*/
      padding: 5px;
      border-radius: 3px;
      color: #bbb;
      /*transform: scale(.8);*/
    }

    .l-r {
      width: 55%;

      .text-icon {
        border: 1px solid #248cfa;
        padding: 5px;
        color: #248cfa;
        border-radius: 20px;
      }
      .image-icon {
        display: inline-block;
        width: 30px;
        height: 30px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .info {
        justify-content: flex-end;

        span {
          margin-right: 15px;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .l-r, .l-l {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 60px;

      .ll-b {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .image-icon {
          width: 25px;
          height: 25px;
          padding: 3px;

          &.eyes:hover {
            background-color: #ccc;
            border-radius: 5px;
            cursor: pointer;
          }

          img {
            width: 100%;
          }

        }
      }

      .circle {
        width: 40px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 16px;
        background-color: #ccc;
        border-radius: 50px;
        transform: scale(.7);
        color: #fff;

        &.active {
          background-color: #248cfa;
          color: #fff;
        }
      }
    }

    .fw700 {
      min-width: 80px;
      font-size: 23px;
      font-weight: 700;
      margin-right: 10px;
    }

    .line {
      line-height: 20px;
      margin-bottom: 10px;
    }

    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    border-bottom: 1px solid #ccc;
    .pingyin {
      position: relative;
      img{
        margin-left: 10px;
        cursor: pointer;
      }
      .pingyin_tag {
        display: flex;
        flex-wrap: wrap;
      }
      .el-popper {
        z-index: 9999 !important;
      }
    }
  }

  .info-right {
    height: 108px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /*padding-top: 10px;*/
    .right-list {
      display: flex;
      justify-content: flex-start;

      .list-key {
        width: 150px;
        color: #a2a2a2;
        letter-spacing: 5px;
        text-align: justify;
        text-align-last: justify;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .list-value {
      width: 70%;

      &-inner {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }

  .userInitialInfo {
    padding: 10px 15px;
    position: absolute;
    z-index: 100;
    width: 500px;
    background-color: #fff;
    height: 80%;
    left: 421px;
    box-shadow: 1px 1px 8px 1px #ccc;
    border-radius: 10px;

    .title {
      color: #248cfa;
      font-size: 20px;
      font-weight: 700;
      padding: 15px 10px;
      border-bottom: 1px solid #248cfa;
    }

    .infoItem {
      text-align: left;
      padding: 10px;

      .infotitle {
        margin-bottom: 10px;
      }

      .content {
        color: #248cfa;
      }
    }

    .userInitialContent {
      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
        background-color: #F5F5F5;
      }

      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        background-color: #FFF;
      }

      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background-color: #AAA;
      }

    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }
}
</style>
